import { Modifier } from '@interfaces/modifier/1.0';
import { Observable } from 'rxjs';

export abstract class AbstractModifierService {
  abstract create(modifier: Partial<Modifier>, brandId: string): Observable<any>;
  abstract getModifiers(brandId: string): Observable<Modifier[]>;
  abstract save(
    catalogEntryId: string,
    modifier: Modifier,
    remove?: string[],
  ): Observable<Modifier>;
}
